(function (app, ng) {

    app.controller("viewFigEventController", viewFigEventController);
    viewFigEventController.$inject = ["$mdDialog"];

    function viewFigEventController($mdDialog) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                close: close
            });

        $ctrl.event.EventDate = moment($ctrl.event.EventDate).format("L");

        function close() {
            $mdDialog.cancel();
        }

    }
})(window.app, window.angular); //jshint ignore:line